import { render, staticRenderFns } from "./ItemMapper.vue?vue&type=template&id=4d455028&scoped=true&"
import script from "./ItemMapper.vue?vue&type=script&lang=js&"
export * from "./ItemMapper.vue?vue&type=script&lang=js&"
import style0 from "./ItemMapper.vue?vue&type=style&index=0&id=4d455028&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d455028",
  null
  
)

export default component.exports